export default __webpack_public_path__ + "static/media/plant.92937945.png";